import React, { memo, Suspense, useCallback } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { RequireAuth } from "./RequireAuth";
import { routeConfig } from "../config/routeConfig";
import { AppRoutesProps } from "@/shared/types/router";

const AppRouter = () => {
    const renderWithWrapper = useCallback((route: AppRoutesProps) => {
        const element = <Suspense fallback={""}>{route.element}</Suspense>;
        return (
            <Route
                key={route.path}
                path={route.path?.replace(/^\//, "")}
                element={
                    route.authOnly ? (
                        <RequireAuth>{element}</RequireAuth>
                    ) : (
                        element
                    )
                }
            />
        );
    }, []);
    return (
        <Routes>
            <Route path="/" element={<Navigate to="/en" replace />} />
            <Route path=":lang" element={<Navigate to="main" replace />} />
            <Route path=":lang">
                {Object.values(routeConfig).map(renderWithWrapper)}
            </Route>
        </Routes>
    );
};

export default memo(AppRouter);
